import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Box, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { common } from '@mui/material/colors';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import jwtDecode from 'jwt-decode';
import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';
import LogoutIcon from '@mui/icons-material/Logout';
import ApartmentIcon from '@mui/icons-material/Apartment';
import UserListApi from '../../service/user.api';

export default function Navbar({
  openMobile,
  onMobileNavOpen,
  onMobileNavClose,
}) {
  const { handleSignout } = useContext(PassportAuth);
  const onSignOut = async () => {
    await handleSignout();
  };

  const [merchantName, setMerchantName] = useState('')
  const [customerName, setCustomerName] = useState('')

  const decoded = jwtDecode(getStorage('token'));
  const customerTaxid = decoded.TAX_ID;
  // const merchantUuid = decoded.UUID;
  const merchantPath = getStorage('merchantPath');

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getMerchantName = async () => {
    try {
      const resp = await UserListApi.getMerchantNameApi(merchantPath);
      setMerchantName(resp.data?.name || '')
    } catch (error) {
      console.log(error);
    }
  }
  const getNameByOneId = async () => {
    try {
      const resp = await UserListApi.getNameByOneIdApi();
      setCustomerName(resp.data?.name || '')
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getMerchantName()
    getNameByOneId()
  }, []);

  return (
    <div>
      <Box sx={{ display: 'flex' }}>
        <AppBar
          position="fixed"
          sx={{
            height: '68',
          }}
        >
          <div className="lg:hidden flex justify-between items-center py-1">
            {/* <button style={{ marginLeft: '10px' }} className="cursor-pointer">
              <MenuIcon
                onClick={() => {
                  if (openMobile) {
                    onMobileNavClose();
                  } else {
                    onMobileNavOpen();
                  }
                }}
                fontSize="large"
                sx={{ color: common.white }}
              />
            </button> */}
            {/* <div className=" py-2 px-2 text-white uppercase">{customerName} <br /> tax id : {customerTaxid}</div> */}
            <div className=" py-2 pl-7 text-white uppercase">{customerName} <br /> <ApartmentIcon sx={{ fontSize: 20 }}/> {merchantName}</div>
            <div className=" border-r-2 border-white" />
            <div className="py-2">
              <IconButton>
                <AccountCircleIcon sx={{ fontSize: 35, color: '#fff' }} />
              </IconButton>
              <IconButton
                aria-controls={open ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                <ArrowDropDownIcon sx={{ fontSize: 35, color: '#fff' }} />
              </IconButton>
              <Menu
                id="fade-menu"
                MenuListProps={{
                  'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
              >
                {/* <MenuItem component={Link} to="/contact" onClick={handleClose}>
                  ติดต่อเรา
                </MenuItem> */}
                <MenuItem
                  onClick={() => {
                    onSignOut();
                  }}
                >
                  <LogoutIcon sx={{ mr: 0.5, fontSize: 16 }} />
                  ออกจากระบบ
                </MenuItem>
              </Menu>
            </div>
          </div>

          <div className='hidden lg:flex justify-between items-center px-4 py-4 text-white'>
            <div className='ml-16'>
              <ApartmentIcon sx={{ fontSize: 30, color: '#fff', mr: 1 }} />
              {merchantName}
            </div>
            <div>
              {customerName}
              {' | '}
              <Button variant='contained' color='secondary' size='small' onClick={() => { onSignOut(); }} sx={{ textTransform: 'none' }}>
                <LogoutIcon sx={{ mr: 0.5, fontSize: 16 }} />
                Logout
              </Button>
            </div>
          </div>
        </AppBar>
      </Box>
    </div>
  );
}
